import { createStyles, FormControl, InputLabel, makeStyles, MenuItem, Select, Theme } from '@material-ui/core';
import React, { useState } from 'react';
import { setFilterChannels, setFilterSubChannels, setSubChannels } from '../../../redux/actions';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { getSubChannels } from '../../../utils/api';
import { useDateFilters } from '../../../utils/hooks';
import Spinner from '../../ui/Spinner/Spinner';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: null,
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 200,
      maxWidth: 200,
    },
  }),
);

const ChannelSelectors = (): JSX.Element => {
  const channels: string[] = useAppSelector((state) => state.filters.channels);
  const subChannels: string[] = useAppSelector((state) => state.filters.subchannels);
  const channelFilters: string[] = useAppSelector((state) => state.filters.filters.channels);
  const subchannelFilters: string[] = useAppSelector((state) => state.filters.filters.subchannels);

  const [startDate, endDate] = useDateFilters();
  const [selectedChannels, setSelectedChannels] = useState<string[]>([]);
  const [selectedSubChannels, setSelectedSubChannels] = useState<string[]>([]);

  const classes = useStyles();
  const dispatch = useAppDispatch();

  const handleChannelChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedChannels(e.target.value as string[]);
    setSelectedSubChannels([]);
  };

  const applyChannelFilters = () => {
    //if filters changed update state
    if (selectedChannels.sort().join(' ') !== channelFilters.sort().join(' ')) {
      dispatch(setFilterChannels(selectedChannels));
      dispatch(setSubChannels([]));
      dispatch(setFilterSubChannels([]));
    }
  };

  const applySubChannelFilters = () => {
    if (selectedSubChannels.sort().join(' ') !== subchannelFilters.sort().join(' '))
      dispatch(setFilterSubChannels(selectedSubChannels));
  };

  const handleSubchannelChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedSubChannels(e.target.value as string[]);
  };

  const fetchSubChannels = () => {
    if (selectedChannels.length > 0 && subChannels.length === 0)
      getSubChannels(startDate, endDate, selectedChannels).then((res) => dispatch(setSubChannels(res)));
  };

  return (
    <>
      <FormControl className={classes.formControl}>
        <InputLabel id="channel-select-label">Channel</InputLabel>
        <Select
          multiple
          labelId="channel-select-label"
          value={selectedChannels}
          onChange={handleChannelChange}
          MenuProps={MenuProps}
          onClose={applyChannelFilters}
        >
          {channels.length > 0 ? (
            channels.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))
          ) : (
            <Spinner height={ITEM_HEIGHT * 5 + ITEM_PADDING_TOP} width={250} color="black" />
          )}
        </Select>
      </FormControl>
      <FormControl className={classes.formControl}>
        <InputLabel id="subchannel-select-label">Subchannel</InputLabel>
        <Select
          multiple
          labelId="subchannel-select-label"
          value={selectedSubChannels}
          onChange={handleSubchannelChange}
          MenuProps={MenuProps}
          disabled={selectedChannels.length === 0}
          onOpen={fetchSubChannels}
          onClose={applySubChannelFilters}
        >
          {subChannels.length > 0 ? (
            subChannels.map((s) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            ))
          ) : (
            <Spinner height={ITEM_HEIGHT * 5 + ITEM_PADDING_TOP} width={250} color="#335153" />
          )}
        </Select>
      </FormControl>
    </>
  );
};

export default React.memo(ChannelSelectors);
